import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TextField, Filter } from 'react-admin';

import makeStyles from '@material-ui/core/styles/makeStyles';

import { Actions as ListActions, Datagrid, List } from 'components/list';
import { ActionField } from 'components/fields';
import SearchInput from 'components/list/SearchInput';

import NameField from '../NameField';
import AddActionButton from './AddActionButton';
import DeleteRewardActionField from './DeleteRewardActionField';
import EditableActionPointsField from './EditableActionPointsField';
import EditActionField from './EditActionField';
import TypeField from './TypeField';

const useStyles = makeStyles((theme) => ({
  form: {
    justifyContent: 'flex-end',
    width: '100%',
    '& .filter-field': {
      width: '50%',
    },
  },
}));

const ActionsFilter = (props) => {
  const classes = useStyles();

  return (
    <Filter classes={classes} {...props}>
      <SearchInput label="Search" source="search" alwaysOn onlySearch loading={props.loading} />
    </Filter>
  );
};

const RewardActions = (props) => (
  <ListActions {...props}>
    <AddActionButton />
  </ListActions>
);

const ActionNameField = ({ record, actionIconOverridesById, ...props }) => {
  const iconOverride =
    record?.id && Object.prototype.hasOwnProperty.call(actionIconOverridesById, record.id)
      ? actionIconOverridesById[record.id]
      : undefined;

  return (
    <NameField {...props} record={iconOverride ? { ...record, iconUrl: iconOverride } : record} />
  );
};

const Actions = (props) => {
  const [actionIconOverridesById, setActionIconOverridesById] = useState<Record<string, string>>(
    {}
  );
  const actionIconOverridesByIdRef = useRef<Record<string, string>>({});

  useEffect(
    () => () => {
      Object.keys(actionIconOverridesByIdRef.current).forEach((actionId) => {
        window.URL.revokeObjectURL(actionIconOverridesByIdRef.current[actionId]);
      });
    },
    []
  );

  const handleActionSaved = useCallback((actionId: string, iconFile?: File) => {
    if (!actionId || !(iconFile instanceof File)) {
      return;
    }

    const iconOverride = window.URL.createObjectURL(iconFile);

    setActionIconOverridesById((prev) => {
      const previousIconOverride = prev[actionId];
      if (previousIconOverride) {
        window.URL.revokeObjectURL(previousIconOverride);
      }

      const next = {
        ...prev,
        [actionId]: iconOverride,
      };
      actionIconOverridesByIdRef.current = next;

      return next;
    });
  }, []);

  return (
    <List
      {...props}
      resource="rewardsAction"
      basePath="/rewardsSettings"
      actions={<RewardActions />}
      filters={<ActionsFilter />}>
      <Datagrid>
        <ActionNameField
          source="title"
          imageSource="iconUrl"
          label="Action"
          actionIconOverridesById={actionIconOverridesById}
        />
        <TextField source="type" label="System integration" sortable={false} />
        <TypeField source="type" label="Type" sortable={false} />
        <EditableActionPointsField source="pointsAwarded" label="Points" sortable={false} />

        <ActionField onActionSaved={handleActionSaved}>
          <EditActionField />
          <DeleteRewardActionField />
        </ActionField>
      </Datagrid>
    </List>
  );
};

export default Actions;
